import { AllowedReducer } from '@leverege/api-redux';
import { LinkAction } from '@leverege/molten/routes';
// import { canGetAllSystemUsers } from '../util/Interface'
import { GlobalState } from '@leverege/ui-redux';
import { canGetAllSystemUsers } from '../util/Interface';
export default LinkAction.create({
  name: 'Search Users',
  id: 'user.link.SearchUsers',
  icon: 'fa-solid fa-users',
  layout: {
    sort: 'z.userManagement.2',
    group: ['userManagement']
  },
  matches: {
    client: 'Main',
    use: 'navBar'
  },
  path: '/searchUsers/',
  isPrepared: cxt => {
    const {
      profile
    } = cxt;
    const a = AllowedReducer.get(GlobalState.get(), profile.id);
    return a.searchUsers != null;
  },
  prepare: async cxt => {
    const {
      profile
    } = cxt;
    const a = AllowedReducer.get(GlobalState.get(), profile.id);
    if (a.searchUsers != null) return null;
    return canGetAllSystemUsers(profile.id);
  },
  handles: cxt => {
    const {
      profile
    } = cxt;
    const a = AllowedReducer.get(GlobalState.get(), profile.id);
    return a.searchUsers === true;
  }
});